

$(document).on('click', '.p-lnb__item--2', ()=> location.href = '/events/2020/201111_festival/bingo' );


promokit.store('layer-reward', promokit.layer({
    el: '#layer-reward',
    render: true,
}));

promokit.store('layer-result', promokit.layer({
    el: '#layer-result',
    render: true,
}));

promokit.store('select', promokit.select({
    el: '#select-1',
    options: [
        {
            value: 1,
            label: '경국지색 / 천명절은천명천명'
        },
        {
            value: 2,
            label: '일확천금 / 냥내려간다',
        },
        {
            value: 3,
            label: '경국지색 / 경국지색에불시착',
        },
        {
            value: 4,
            label: '일확천금 / 무구정광대다라니'
        }
    ],
    selected: -1,
    placeholder: '보상 아이템을 받을 캐릭터를 선택해 주세요',
    disabled: false
}));


if( promokit.store('staticPath').indexOf('local') > 0 || promokit.store('staticPath').indexOf('op') > 0){
    promokit.store('commentId', '5fa3472663a46a0001bb0725');
}
else if( promokit.store('staticPath').indexOf('rc') > 0 ){
    promokit.store('commentId', '5fa347c5f2daa60001cdae63');
}
else {
    promokit.store('commentId', '5fa348101dc1600001817453');
}

let page = promokit.page({
    caution: '#section-caution',
    cnb: true, //true, false
    topButton: true, //true, false
    footer: {
        theme: 'white' //'black', 'white'
    },
    headerButton: {
        el: '.header-button',
        cookie: false,
        home: true,
        event: true,
        update: false,
        sns: true,
        theme: 'black' //'black', 'white'
    },
    remote: false,
    comment: [
        {
            el:'#section-comment',
            commentTextMaxCount: 300,
            commentListSize: 20,
            articleId: promokit.store('commentId'),
        }
    ]
});




// WEBPACK FOOTER //
// ./src/js/polaei.js